import { useNavigate } from 'react-router-dom'
import ProjectArrow from '../../../assets/images/icons/projectarrow.svg'
import { trackClarityEvent } from "../../../app/utils/ClarityAnalytics";
import { trackEvent } from "../../../app/utils/firebaseEvents";
import { CLARITY_EVENTS } from "../../../app/utils/EventTypes";

type PortfolioCardProps = {
  image: string
  title: string
  description: string
  link?: string
}

type PortfolioCardItem = {
  image: string
  title: string
  description: string
  link?: string
}

type PortfolioCardRowProps = {
  items: PortfolioCardItem[]
}

const PortfolioCard = ({ image, title, description, link }: PortfolioCardProps) => {
  const navigate = useNavigate()

  return (
    <div
      onClick={() => link && navigate(link)}
      className={`group relative flex shrink-0
      h-[180px] sm:h-[180px] md:h-[220px] lg:h-[250px] xl:h-[320px] 2xl:h-[450px]
      w-[220px] sm:w-[240px] md:w-[200px] lg:w-[250px] xl:w-[350px] 2xl:w-[450px]
      rounded-[35px] overflow-hidden transition-all duration-500 ease-out
      hover:w-[310px] sm:hover:w-[340px] md:hover:w-[390px] lg:hover:w-[440px] xl:hover:w-[520px] 2xl:hover:w-[550px]
      ${link ? 'cursor-pointer' : ''}`}
    >
        <div className="absolute bottom-1/15 -translate-y-1/2 left-[90px] -translate-x-1/2 sm:left-[100px] md:left-[110px] lg:left-[120px] xl:left-[120px] 2xl:left-[120px] z-20 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out pointer-events-auto cursor-pointer">
        <img src={ProjectArrow} alt="arrow" className="w-12 h-12 object-contain drop-shadow-lg" />
      </div>

      {/* LEFT PANEL */}
      <div className="absolute inset-y-0 left-0 z-10 flex w-[90px] items-center justify-center rounded-[35px] border border-r-0 border-white/90 bg-purple/90 text-white opacity-0 -translate-x-2 transition-all duration-500 ease-out group-hover:translate-x-0 group-hover:opacity-100 sm:w-[100px] md:w-[110px] lg:w-[120px] xl:w-[120px] 2xl:w-[120px]">
        <div className="-rotate-90 flex flex-col items-start">
          <h3 className="text-xl font-bold font-rajdhani w-[300px] leading-tight">{title}</h3>
          <p className="text-sm w-[300px] pb-4 font-gilroy-medium text-white/90">{description}</p>
        </div>
      </div>

      {/* IMAGE */}
      <div className="ml-0 h-full w-full overflow-hidden rounded-[35px] border border-transparent transition-all duration-500 ease-out group-hover:ml-[90px] group-hover:border-2 group-hover:border-purple sm:group-hover:ml-[100px] md:group-hover:ml-[110px] lg:group-hover:ml-[120px] xl:group-hover:ml-[120px] 2xl:group-hover:ml-[120px]">
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </div>
    </div>
  )
}

export const PortfolioCardRow = ({ items }: PortfolioCardRowProps) => {
  const navigate = useNavigate()
      
  const handleviewallproject = () => {
    const payload = {
      source: 'portfolio_section',
      page: window.location.pathname,
    };

    trackClarityEvent(CLARITY_EVENTS.VIEW_ALL_OUR_PROJECTS, payload);
    trackEvent(CLARITY_EVENTS.VIEW_ALL_OUR_PROJECTS, payload);

    navigate('/portfolio');
  };

  return (
    <div className="w-full">  

      {/* 🔥 CARD CONTAINER (unchanged) */}
      <div className="overflow-hidden">
        <style>{`
          @keyframes portfolioMarquee {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-33.333333%); }
          }
        `}</style>

        <div className="flex w-max gap-6 animate-[portfolioMarquee_34s_linear_infinite]">
          {[0, 1, 2].map((loopIndex) => (
            <div key={loopIndex} className="flex shrink-0 gap-6">
              {items.map((item, i) => (
                <PortfolioCard key={`${loopIndex}-${i}`} {...item} />
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* 🔥 BOTTOM BUTTON */}
      <div className="flex justify-center mt-12">
        <button
         onClick={handleviewallproject}
          className="px-6 py-3 rounded-3xl bg-purple md:text-lg xl:text-lg 2xl:text-xl text-white font-semibold hover:opacity-90 transition"
        >
          View All Our Projects
        </button>
      </div>

    </div>
  )
}

export default PortfolioCard